/* eslint-disable @next/next/no-img-element */
'use client';
import React from 'react';

import * as Styled from './styled';

import { IRepository, IRepositoryEntry } from '@/types';
import { BASE_API_URL } from '@/config/environment';

const ImageFileView: React.FC<{
  repository: IRepository;
  entry?: IRepositoryEntry;
  proportion?: number;
  fileUrl?: string;
}> = ({ repository, entry, proportion, fileUrl }) => {
  const url =
    fileUrl ||
    entry?.testUrl ||
    `${BASE_API_URL}/repos/${repository.namespace}/${repository.name}/file/${entry?.resource?.version}/${entry?.resource?.path}`;

  return (
    <Styled.ImageFileView $proportion={proportion}>
      <img src={url} alt={entry?.filename} />
    </Styled.ImageFileView>
  );
};

export default ImageFileView;
